import React, { useEffect } from "react";
import monitor from "../../../../../images/monitor.png";
import { FaStar, FaCalendarAlt } from "react-icons/fa";

// Estilo personalizado con animación de borde RGB
const customStyles = `
  @keyframes rgbEffect {
    0% { background-color: rgba(171, 71, 188, 0.8); }  /* Púrpura */
    25% { background-color: rgba(66, 165, 245, 0.8); }  /* Azul */
    50% { background-color: rgba(255, 87, 34, 0.8); }  /* Naranja */
    75% { background-color: rgba(76, 175, 80, 0.8); }  /* Verde */
    100% { background-color: rgba(171, 71, 188, 0.8); }  /* Púrpura */
  }
  
  @keyframes borderRgbEffect {
    0% { box-shadow: 0 0 10px rgba(171, 71, 188, 0.7); }
    25% { box-shadow: 0 0 10px rgba(66, 165, 245, 0.7); }
    50% { box-shadow: 0 0 10px rgba(255, 87, 34, 0.7); }
    75% { box-shadow: 0 0 10px rgba(76, 175, 80, 0.7); }
    100% { box-shadow: 0 0 10px rgba(171, 71, 188, 0.7); }
  }
  
  @keyframes borderColorRotate {
    0% { border-color: rgba(171, 71, 188, 0.7); }
    25% { border-color: rgba(66, 165, 245, 0.7); }
    50% { border-color: rgba(255, 87, 34, 0.7); }
    75% { border-color: rgba(76, 175, 80, 0.7); }
    100% { border-color: rgba(171, 71, 188, 0.7); }
  }
  
  .rgb-border {
    border: 2px solid rgba(171, 71, 188, 0.7);
    animation: borderColorRotate 5s infinite linear;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.5), 0 0 10px rgba(171, 71, 188, 0.3) inset;
  }
  
  .feature-card {
    position: relative;
    overflow: hidden;
  }
  
  .feature-card:hover .feature-icon {
    animation: rgbEffect 5s infinite;
  }
  
  .feature-card:hover {
    animation: borderRgbEffect 5s infinite;
  }
`;

const FeatureItem = ({ imgSrc, IconComponent, title, description, delay }) => (
  <div className="feature-card p-5 md:p-6 rounded-xl bg-zinc-900 hover:bg-zinc-800 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl"
       style={{ animationDelay: delay }}>
    <div className="feature-icon bg-purple-700 p-3 md:p-4 rounded-full w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 md:mb-6 transition-all duration-300">
      {imgSrc ? <img src={imgSrc} alt={title} className="w-7 h-7 md:w-8 md:h-8" /> : <IconComponent className="w-7 h-7 md:w-8 md:h-8" />}
    </div>
    <h3 className="text-xl md:text-2xl font-semibold mb-2 md:mb-3">{title}</h3>
    <p className="text-zinc-300 text-sm md:text-base">{description}</p>
  </div>
);

export const FeaturesSection = () => {
  // Añadimos los estilos al documento cuando el componente se monta
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = customStyles;
    document.head.appendChild(styleSheet);
    
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  return (
    <section className="py-16 md:py-24 bg-black text-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Una nueva forma de disfrutar la comedia
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-12 text-center max-w-6xl mx-auto">
          <FeatureItem
            imgSrc={monitor}
            title="Disponible en todos tus dispositivos"
            description="Mira los mejores shows de stand-up desde tu navegador o pantalla favorita."
            delay="0s"
          />
          <FeatureItem
            IconComponent={FaStar}
            title="Contenido exclusivo"
            description="Disfruta de rutinas y shows que solo encontrarás en nuestra plataforma."
            delay="0.2s"
          />
          <FeatureItem
            IconComponent={FaCalendarAlt}
            title="Estrenos semanales"
            description="Accede a nuevo contenido cada semana con los mejores comediantes del momento."
            delay="0.4s"
          />
        </div>
      </div>
    </section>
  );
};